import { Checkbox, Collapse } from 'antd'
import React from 'react'

const { Panel } = Collapse

export const SmsSetting = ({ smsConfig, onSmsChange }) => {
    const onChange = (e) => {
        onSmsChange(e.target.checked)
    }

    return (
        <Collapse style={{ marginBottom: '3px' }}>
            <Panel header="SMS">
                <Checkbox checked={smsConfig} onChange={onChange}>SMS</Checkbox>
            </Panel>
        </Collapse>
    )
}

export default SmsSetting
